import styled from "styled-components";
import theme from "./theme";

const middleGray02 = theme.colors.middleGray02;
const mainBlack = theme.colors.mainBlack;
const mainWhite = theme.colors.mainWhite;
const sideMenu = theme.colors.sideMenu;
const lightGray01 = theme.colors.lightGray01;
const opacity_40 = theme.colors.opacity_40;
const md = theme.screens.md;

export const BreakLine = styled.div<{$height:number}>`
    display: flex;
    align-items: center;
    width: 900px;
    height: ${props => props.$height}px;

    & .horizontal-10-blk {
        width: 100%;
        border-bottom: 1px solid ${mainBlack};
    }

    & .horizontal-05-blk {
        width: 100%;
        border-bottom: 0.5px solid ${mainBlack};
    }
`;

export const PostCodeBox = styled.div`
    padding: 10px 0;
    width: 100%;
    
    & > div {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        margin-bottom: 10px;
    }
    
    & input {
        height: 40px;
        border: 0.5px solid ${middleGray02};
        border-radius: 5px;
        text-indent: 10px;
        outline: none;
        flex: 1;

        &::placeholder {
            font-size: 14px;
            font-weight: 300;
        }
    }

    & span {
        font-size: 12px;
        font-weight: 600;
    }

    & .zipcode-input {
        flex: 1;
    }

    & .postcode-input {
        width: 100%;
    }
`;

export const SearchPostButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 120px;
    height: 40px;
    padding: 0 16px;
    border: 0.5px solid ${middleGray02};
    border-radius: 5px;
    background-color: ${mainWhite};
    color: ${mainBlack};
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    outline: none;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    flex-shrink: 0;

    &:hover:not(:disabled) {
        background-color: ${mainBlack};
        color: ${mainWhite};
        border-color: ${mainBlack};
    }

    &:disabled {
        background-color: ${sideMenu};
        color: ${middleGray02};
        border-color: ${lightGray01};
        cursor: not-allowed;
    }

    &:active:not(:disabled) {
        transform: scale(0.98);
    }
`;

export const SpinnerContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${opacity_40};
    z-index: 9999999;

    & .spinner-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        & .spinner-text {
            margin-top: 20px;
            text-align: center;
            color: white;
            font-size: 13px;
            letter-spacing: .2rem;
        }
    }
`;

export const NotFoundContainer = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: #E9E9EB;
    z-index: 99999999;

    & .main-box {
        display: flex;
        justify-content: center;
        align-items: end;
        gap: 30px;

        @media ${md} {
            display: block;
        }

        & .logo-box {

            @media ${md} {
                margin-bottom: 60px;
            }

            & img {

                @media ${md} {
                    width: 145px;
                    height: 145px;
                    margin: 0 auto;
                }
            }
        }

        & .content-box {

            & .text-box {

                @media ${md} {
                    text-align: center;
                }

                & :nth-child(1) {
                    font-size: 69px;
                    font-weight: 500;
                    word-spacing: 5px;
                    letter-spacing: 0.8px;
                }

                & :nth-child(2) {
                    font-size: 29px;
                    letter-spacing: -0.5px;
                }

                & :nth-child(3) {
                    margin-top: 30px;
                    line-height: 20px;
                    font-size: 14px;
                    letter-spacing: -0.4px;
                }
            }

            & .button-box {
                display: flex;
                gap: 10px;
                margin-top: 30px;

                @media ${md} {
                    display: block;
                    margin-top: 60px;
                }

                & button {
                    width: 145px;
                    height: 40px;
                    border: 1px solid #000;
                    border-radius: 30px;
                    font-size: 14px;

                    @media ${md} {
                        width: 100%;
                    }
                }

                & :nth-child(2) {
                    background-color: #000;
                    color: #FFF;

                    @media ${md} {
                        margin-top: 11px;
                    }
                }
            }
        }
    }
`;

export const NoticeSelectOneContainer = styled.div`
    width: 100%;
    margin: 40px 0 60px;

    & .notice-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        line-height: 32px;
        font-weight: 600;
        border-bottom: 1px solid ${theme.colors.middleGray01};

        & button {
            font-size: 13px;
            font-weight: 400;
        }
    }

    & .register-text {
        width: 100%;
        display: flex;
        justify-content: end;
        font-size: 15px;
        font-weight: 300;
        margin-top: 15px;
    }

    & .notice-content-box {
        padding: 20px 0;
        min-height: 500px;
    }

    & .download-announcement {
        line-height: 30px;
        font-weight: 600;
    }
    
    & .download-box {
        padding: 10px;
        border: 1px solid ${theme.colors.middleGray02};
        color: ${theme.colors.middleGray02};

        & .download-item a{
            font-size: 15px;
            line-height: 24px;
            text-decoration: underline;

            &:hover {
                color: ${theme.colors.darkGray};
            }
        }
    }
`;

export const PopupNoticeContainer = styled.div`
    position: absolute;
    left: 5%;
    top: 15%;
    padding-top: 20px;
    max-width: 468px;
    width: 468px;
    border: 2px solid #000;
    background-color: ${theme.colors.mainWhite};
    box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
    z-index: 99;

    & .popup-wrapper {
        position: relative;
        overflow-y: scroll;
        width: 100%;
        height: 584px;
        padding: 0 20px 60px;
    
        & .notice-title-box {
            font-size: 20px;
            font-weight: 600;
            padding-bottom: 15px;
            margin-bottom: 15px;
            border-bottom: 2px solid #000;
        }
    
        & .content-box {
            width: 100%;
        }

        & .show-detail-box {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 20px 0 0;

            & button {
                width: 100%;
                padding: 15px;
                border: 1px solid ${theme.colors.mainBlack};
            }
        }

    }

    & .popup-layout {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        bottom: 0;
        height: 50px;
        background-color: #fafafa;
        border-top: 1px solid #e8e8e8;

        & .popup-footer {
            display: flex;
            justify-content: space-between;
            width: 100%;

            & button {
                padding: 15px;
                font-size: 14px;
            }
        }
    }

    & .navigation {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 60px;
        height: 60px;
        background-color: rgba(0, 0, 0, 0.3);

        &.prev {
            left: 0;

            & img {
                transform: translateX(15px);
            }
        }
        &.next {
            right: 13px;

            & img {
                transform: translateX(20px) rotate(180deg);
            }
        }
    }

    & .index-display {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 65px;
        width: 100%;

        & .wrapper {
            background-color: rgba(0, 0, 0, 0.3);
            width: 70px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            border-radius: 20px;
            color: #fff;
            font-size: 15px;
            font-weight: 600;
        }
    }
`;

export const PrivacyPolicyContainer = styled.div`
    padding-top: 40px;

    & .privacy-title {
        margin-bottom: 40px;
        font-size: 32px;
        font-weight: 600;
        text-align: center;
    }
    
    & .intro {
        margin: 20px 0;
        font-size: 14px;
        font-weight: 700;
    }

    & .law {
        padding: 12px;
        padding-left: 30px;
        margin: 30px 0 20px;
        background-color: #f7f7f7;
        border-bottom: 1px solid #ddd;
        border-left: 3px solid #ddd;
        font-size: 16px;
        font-weight: 700;
    }

    & .law-content {
        margin: 20px 0;
        font-size: 14px;
        line-height: 18px;
    }
`;